import React, { useCallback } from 'react';
import { IAdventureTravelRouteProduct } from 'components/domain/fdr-adventure-travel-routes';
import FdrGeoTrips from 'components/domain/fdr-geo/trips/fdr-geo-trips';
import { FdrGeoContentQuery } from 'schemas/query/geo/fdr-geo-content.generated';
import useGeoMapRoundTrips, {
  TGeoMapRoundTripMap,
} from './use-geo-map-round-trips';

const renderMap = (
  name: string,
  adventureTravels: IAdventureTravelRouteProduct[],
  roundTripMap: TGeoMapRoundTripMap,
  isCountry: boolean,
  isB2b: boolean,
  isNewDesignEnabled: boolean,
  id: string
) => {
  if (!isCountry || !adventureTravels?.length) return null;

  return (
    <>
      {isNewDesignEnabled && (
        <FdrGeoTrips
          products={adventureTravels}
          related={Array.from(roundTripMap.values())}
          country={name}
          isB2b={isB2b}
          key="map"
          id={id}
        />
      )}
    </>
  );
};

const useMap = (
  geo: FdrGeoContentQuery['fdrGeo'],
  isCountry: boolean,
  isB2B: boolean,
  isNewMapDesignEnabled: boolean,
  id: string
) => {
  const geoMapProductData = useGeoMapRoundTrips(id);

  return useCallback(() => {
    return renderMap(
      geo.name,
      geoMapProductData.adventureTravels,
      geoMapProductData.roundTripMap,
      isCountry,
      isB2B,
      isNewMapDesignEnabled,
      id
    );
  }, [
    geo,
    geoMapProductData?.roundTripMap,
    isCountry,
    isB2B,
    isNewMapDesignEnabled,
    id,
  ]);
};

export default useMap;
